import request from './request'

// 获取设备类型列表
export function deviceTypeList (data) {
  return request.get('en/deviceType/list', data)
}
// 获取设备列表
export function getDeviceList (data) {
  return request.get('en/device/list', data)
}
// 新增设备
export function addDevice (data) {
  return request.post('en/device/add', data, 'json')
}
// 修改
export function updateDevice (data) {
  return request.post('en/device/update', data, 'json')
}
// 删除
export function deleteDevice (data) {
  return request.post('en/device/delete', data)
}
// 批量保存
export function patchUpdateDevice (data) {
  return request.post('en/device/patchUpdate', data, 'json')
}
